import {
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput as CNumberInput,
  NumberInputField,
  NumberInputProps as CNumberInputProps,
  NumberInputStepper,
  StyleProps,
} from '@chakra-ui/react';
import { FieldProps } from 'formik';

export interface NumberInputProps extends CNumberInputProps, FieldProps {
  showStepper?: boolean;
  children?: React.ReactNode;
  $valueStyle?: StyleProps;
}

export const NumberInput = ({
  field,
  form,
  meta,
  showStepper = true,
  children,
  $valueStyle,
  ...restProps
}: NumberInputProps) => {
  const { name } = field;
  const { setFieldValue } = form;
  const { touched, error } = meta;

  const $setFieldValue = (value: any) => setFieldValue(name, value);

  return (
    <CNumberInput
      {...field}
      id={name}
      onChange={(value) => $setFieldValue(value)}
      isInvalid={!!error && touched}
      {...restProps}
    >
      <NumberInputField {...$valueStyle} />
      {showStepper && (
        <NumberInputStepper>
          <NumberIncrementStepper />
          <NumberDecrementStepper />
        </NumberInputStepper>
      )}
      {children}
    </CNumberInput>
  );
};

export default NumberInput;
